import { Menu as MenuMui } from '@mui/base/Menu';
import { MenuButton } from '@mui/base/MenuButton';
import { Dropdown as DropdownMui } from '@mui/base/Dropdown';
import { MenuItem as IMenuItem } from '../../../NavBar';
import { Icon, enums } from 'edrolo-ui';
import { useAnalytics } from 'edrolo/analytics';
import { MenuItem } from './MenuItem';
import styles from './styles.scss';

interface MenuProps {
  buttonTitle: string;
  menuItems: Record<string, IMenuItem[]>;
}

export const Menu = ({ buttonTitle, menuItems }: MenuProps): JSX.Element => {
  const { track } = useAnalytics({});

  return (
    <DropdownMui
      onOpenChange={(_, isOpen) => {
        if (isOpen) {
          track(`navbar menu clicked`);
        }
      }}
    >
      <MenuButton className={styles.menuButton}>
        {buttonTitle}
        <Icon name={enums.Icons.CHEVRON_DOWN} />
      </MenuButton>
      <MenuMui
        slotProps={{
          root: {
            placement: 'bottom-start',
            className: styles.root,
          },
          listbox: { className: styles.listbox },
        }}
      >
        {Object.keys(menuItems).map((sectionTitle, index) => (
          <div key={index} className={styles.menuSection}>
            <div className={styles.menuSectionLabel}>{sectionTitle}</div>

            <ul>
              {menuItems[sectionTitle].map((menuItem, subIndex) => (
                <MenuItem key={subIndex} menuItem={menuItem} />
              ))}
            </ul>
          </div>
        ))}
      </MenuMui>
    </DropdownMui>
  );
};
